import { FacetId } from '../../types.js';

function hasProductTypeFacet(searchState, facets) {
    const productTypeFacet = facets.find((facet)=>facet.id === FacetId.productType
    );
    const val = productTypeFacet && searchState.refinementList && searchState.refinementList[productTypeFacet.attribute];
    return (val || []).length > 0;
}

export { hasProductTypeFacet as default };
//# sourceMappingURL=has-Product-type-facet.js.map
